var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "new-year-snowfall", attrs: { "aria-hidden": "true" } },
        [
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❄")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❅")]),
          _vm._v(" "),
          _c("div", { staticClass: "snowflake" }, [_vm._v("❆")]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }